module.exports = __webpack_public_path__ + "static/media/2C.5478bcbf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/2C.pdf
// module id = 83
// module chunks = 0